import { motion } from "framer-motion";
import { systemBlack, systemBlue, systemWhite } from "../../../constants";
import { createStyledElement } from "../../../../../utils/createStyledElement";

export const Container = createStyledElement(
  "header",
  ({ $showButtons }) => ({
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    display: "flex",
    justifyContent: $showButtons ? "center" : "space-between",
    alignItems: "center",
    padding: $showButtons ? 12 : "12px 10px",
    background: "white",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    zIndex: 20,
    boxSizing: "border-box",
    gap: 8,
  }),
  ["$showButtons"]
);

export const Image = createStyledElement("img", {
  width: "clamp(96px, 34vw, 167px)",
  height: "auto",
  maxHeight: 40,
  minWidth: 0,
});

export const MenuButton = createStyledElement("button", {
  background: "none",
  border: "none",
  cursor: "pointer",
  minWidth: 44,
  minHeight: 44,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  touchAction: "manipulation",
});

export const ButtonsContainer = createStyledElement("div", {
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: 6,
  minWidth: 0,
  flex: 1,
});

export const MenuOverlay = createStyledElement(motion.div, {
  position: "fixed",
  top: 0,
  right: 0,
  width: "100%",
  maxWidth: 420,
  height: "100%",
  background: "white",
  boxShadow: "-2px 0 10px rgba(0, 0, 0, 0.1)",
  padding: 20,
  display: "flex",
  flexDirection: "column",
  gap: 16,
  zIndex: 21,
  overflowY: "auto",
});

export const CloseButton = createStyledElement("button", {
  background: "none",
  border: "none",
  alignSelf: "flex-end",
  cursor: "pointer",
  minWidth: 44,
  minHeight: 44,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
});

export const NavLinks = createStyledElement("nav", {
  display: "flex",
  flexDirection: "column",
  gap: 12,
  fontSize: 18,
});

export const NavItem = createStyledElement("button", {
  cursor: "pointer",
  padding: "8px 0",
  font: '600 18px/22px "Roboto", sans-serif',
  color: systemBlack,
  background: "none",
  border: "none",
  textAlign: "left",
  touchAction: "manipulation",
});

export const LangSwitcher = createStyledElement("div", {
  marginTop: "auto",
  display: "flex",
});

export const Lang = createStyledElement(
  "button",
  ({ $isActive }) => ({
    cursor: "pointer",
    padding: 10,
    borderRadius: 4,
    color: $isActive ? systemBlack : "#90989F",
    backgroundColor: $isActive ? "#F5F7FA" : systemWhite,
    font: '400 16px/12px "Roboto", sans-serif',
    textAlign: "center",
    border: "none",
  }),
  ["$isActive"]
);

export const Icon = createStyledElement("i", {
  fontSize: 24,
  color: systemBlue,
});
